export const paths = {
  TransactionsWithActionsPage: '/transakcje/transakcje-wymagajace-akcji',
  CennikiPage: '/ceny/cenniki',
  CiagiNumeracjePage: '/konfiguracja/ciagi-numeracji',
  FileUploaderPage: '/CMS/manager-plikow',
  JezykiPage: '/CMS/jezyki',
  KategorieCechyPage: '/konfiguracja/kategorie-cechy-definicje',
  KategoriePage: '/konfiguracja/kategorie-cechy-ustawienia',
  KomunikatoryPage: '/klienci/wiadomosci',
  KoszykiPage: '/transakcje/koszyki',
  KrajePage: '/konfiguracja/kraje',
  LogiPage: '/administracja/logi',
  ParametryPage: '/konfiguracja/parametry',
  PromocjePage: '/ceny/promocje',
  ReklamyPage: '/marketing/reklamy',
  SklepyPage: '/konfiguracja/sklepy',
  SklepyTowaryWykluczeniaPage: '/towary/wykluczenia-na-sklepach',
  StronyStatycznePage: '/CMS/strony-statyczne',
  BlogPage: '/CMS/blog',
  TlumaczeniaPage: '/CMS/tlumaczenia',
  TowaryPage: '/towary/towary-lista',
  UzytkownicyPage: '/administracja/uzytkownicy-backoffice',
  KlienciListaPage: '/klienci/lista',
  WalutyPage: '/konfiguracja/waluty',
  ZamowieniaPage: '/transakcje/zamowienia',
  WiadomosciSzablonyPage: '/konfiguracja/szablony-wiadomosci',
  RaportyStartowePage: '/home',
  TowaryCena: '/ceny/ceny-bazowe',
  TowaryOpiniePage: '/towary/towary-opinie',
  CenyWyliczonePage: '/ceny',
  PromoPage: '/ceny/promocje',
  Import: '/ceny/import',
  JednostkiMiar: '/PIM/cechy/jednostki-miar',
  CechyGrupyPage: '/PIM/cechy/cechy-grupy',
  CechySlowniki: '/PIM/cechy/cechy-slowniki',
  CechyPage: '/PIM/cechy/cechy-definicje',
  FormyPlatnosciPage: '/formy-platnosci',
  CechyTowaryTypyPage: '/PIM/cechy/cechy-towary-typy',
  CechyTowaryMarkiPage: '/cechy-towary-marki',
  CechyTowaryModelePage: '/cechy-towary-modele',
  CechyWariantyPozycjePage: '/cechy-warianty-pozycje',
  CechyTowaryTypyEdycja: '/PIM/cechy/typy-towarow',
  CechyTowaryTypySzablony: '/PIM/cechy/szablony-opisowe',
  CechyTowaryTypyWariantyDostepne:
    '/PIM/cechy/cechy-towary-typy-warianty-dostepne',
  CechyWarianty: '/PIM/cechy/cechy-warianty',
  OpisywanieTowarowPage: '/opisywanie-towarow',
  OpisywanieTowarowZbiorczePage: '/opisywanie-towarow-zbiorcze',
  KategorieProduktowePage: '/PIM/Towary/kategorie-produktowe',
  CechyZdjeciaTypyPage: '/PIM/cechy/zdjecia-typy',
  CechyPlikiTypyPage: '/PIM/cechy/pliki-typy',
  CechyKanalyTypyPage: '/PIM/cechy/kanaly-typy',
  TowaryPowiazaniaPage: '/towary-powiazania',
  TowaryPowiazaniaCechyWspolnePage: '/towary-powiazania-cechy-wspolne',
  TowaryPowiazaniaWarunkiPage: '/towary-powiazania-warunki',
  TowaryImportExport: '/opisywanie/import-export',
  KreatoryProduktowPage: '/PIM/kreatory-produktow',
  KreatorDefinicjeTypyPage: '/PIM/kreator-definicje-typow',
  TlumaczeniaSeoPage: '/tlumaczenia-seo',
  TlumaczeniaRoutesPage: '/routes',
  KategorieTowaryPolaczPage: '/kategorie-towary-polacz',
  TowarKategoriePolaczPage: '/towar-kategorie-polacz',
  WalidacjaImion: '/walidacja-imion',
  WalidacjeKodowPocztowych: '/walidacja-kodow-pocztowych',
  TlumaczeniaSeoAgencjaPage: '/tlumaczenia-seo-agencja',
  AnkietyPage: '/marketing/ankiety',
  WysylkiCzasyDostawyPage: '/konfiguracja/wysylki-czasy-dostawy',
  UzytkownicyWebCzarnaListaPage: '/klienci/czarna-lista',
  ZamowienieEdycja: '/zamowienia/:id',
  TowarPodglad: '/towar/:id',
  RabatPage: "/rabaty/"
};
